import React, { useEffect, useState } from 'react'
import { IBaseDynamicFormElement } from '../Form/DynamicForm'
import { Alert, TextField } from '@mui/material'
import { useDispatch } from 'react-redux'
import AlertElement from '../AlertElement'
import GoogleMap from './GoogleMap'

export const extractUrlFromEmbedeGoogleMap = (url: string) => {
    const srcMatch = url.match(/src="([^"]+)"/)
    return srcMatch ? srcMatch[1] : null
}

export default function GoogleMapsEmbeded(props: IBaseDynamicFormElement) {

    const { id, label, fullWidth, handleOnChange, data, multiline, maxRows, minRows, handleKeyUp, enableQrCodeScanner, validateInput, placeholder, enableStrongPassword } = props

    const dispatch = useDispatch()

    const [message, setMessage] = useState<string>("")

    const onChange = (id: string, value: any) => {
        const map: string | null = extractUrlFromEmbedeGoogleMap(value)

        if (!map){
            setMessage("Invalid link. You must paste embded google maps link")
            return;
        }else{
            setMessage("")
        }

        handleOnChange(id, map)
    }

    useEffect(() => {

        if (!data.value){
            setMessage("Copy and paste Embeded iframe from Google Maps page")
        }

    }, [data])

    return(
        <div className="google-map-field-container">
            <div className="content-of-google-map-field-container">

                <TextField 
                    id={id} 
                    error={data.helperTextType == "error" ? true : false} 
                    type="text"
                    label={label} 
                    placeholder={placeholder}
                    variant="outlined" 
                    fullWidth={fullWidth} 
                    value={data.value} 
                    onChange={(e) => onChange(id, e.target.value)} 
                    multiline={multiline}
                    maxRows={maxRows}
                    minRows={minRows}
                    onKeyUp={(e: React.KeyboardEvent<HTMLDivElement>) => {
                        if (handleKeyUp){
                            handleKeyUp(e)
                        }
                    }}        
                />

                {message && <div style={{ marginTop: 5 }}><AlertElement type="info" message={message} /></div>}

                {data.value && <GoogleMap url={data.value} />}

            </div>
        </div>
    )
}